import {Sentry} from 'app/core/error-handler/sentry.service';
import {AuthService} from 'app/core/services/auth.service';
import {catchError} from 'rxjs/operators';

export function setCurrentUserToSentry(sentry: Sentry, auth: AuthService) {
    return () => {
        auth.currentUser$
            .pipe(
                catchError(e => {
                    sentry.handleError(e);
                    return null;
                })
            )
            .subscribe(user =>
                sentry.setUserContext(
                    user
                        ? Object.keys(user).reduce((acc, key) => {
                              acc[key] = JSON.stringify(user[key]);
                              return acc;
                          }, {})
                        : null
                )
            );
        return Promise.resolve();
    };
}
